// extracted by mini-css-extract-plugin
export default {"pictureCont":"zYVnU","avatar":"iotYB"};